import React from 'react'
import ContentfulJsonLdBlocks from '../../src/components/shared/ContentfulJsonLdBlocks'
import PropTypes from 'prop-types'
import Layout from '../../src/components/layouts'
import BlogPage from '../../src/components/pages/Blog'
import BlogListingService from '../../src/services/BlogListingService'
import { BLOG_LISTING_PAGE_SIZE } from '../../src/services/blogListing/constants'
import { generateSeoData } from '../../src/common/nextSeoUtils'
import { getFullUrlFromReq } from '../../src/common/serverUtils'
import logger from '../../src/common/logger'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'
import { getContentfulJsonLd } from 'src/common/getContentfulJsonLd'

export async function getServerSideProps({ preview, req }) {
  let categories = []
  let posts = {}
  let jsonLdSchemas = null

  try {
    const [listingResult, jsonLd] = await Promise.all([
      BlogListingService.getInstance().getListing({
        page: 1,
        limit: BLOG_LISTING_PAGE_SIZE,
        preview,
      }),
      getContentfulJsonLd('blog/'),
    ])
    posts = listingResult.posts
    categories = listingResult.posts.categories
    jsonLdSchemas = jsonLd
  } catch (error) {
    logger.error('Blog page: GraphQL listing failed', { error })

    return { notFound: true }
  }

  const pagePid = ['blog']

  const { canonicalUrl } = getFullUrlFromReq(req, pagePid)

  const seoData = generateSeoData({
    title: `Blog - All Articles | Freedom Debt Relief`,
    url: canonicalUrl,
    description: `Financial information and advice on debt relief, debt consolidation, home equity, personal finance tips and more.`,
  })

  return {
    props: {
      categories,
      posts,
      seoData,
      jsonLdSchemas,
    },
  }
}

const Blog = ({ categories, posts, seoData, jsonLdSchemas }) => {
  return (
    <Layout footerClassName="max-w-1400">
      <WithSeoOverrides {...seoData} />
      <BlogPage categories={categories} posts={posts} />
      <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
    </Layout>
  )
}

Blog.propTypes = {
  categories: PropTypes.array.isRequired,
  posts: PropTypes.object.isRequired,
  seoData: PropTypes.object.isRequired,
}

export default Blog
